import XEnhancedPreviewService from './xEnhancedPreviewService';

// Service principal pour les prévisualisations X
// Essaie l'API réelle en premier, puis fallback vers Enhanced


export interface XPreviewData {
  id: string;
  username: string;
  displayName: string;
  avatar?: string;
  content: string;
  createdAt: string;
  verified?: boolean;
  media?: string[];
  likes?: number;
  retweets?: number;
  replies?: number;
  isReal?: boolean;
}

/**
 * Service pour récupérer les données d'un tweet X
 * Essaie l'API réelle via proxy backend, puis fallback intelligent
 */
export class XPreviewService {
  /**
   * Point d'entrée principal - essaie l'API réelle puis fallback
   */
  static async getTweetData(tweetId: string, username: string): Promise<XPreviewData> {
    try {
      console.log('🔍 Tentative API X réelle via proxy backend...');
      
      // Essayer d'abord l'API réelle via le proxy backend
      const realData = await this.tryRealApiViaProxy(tweetId);
      if (realData) {
        console.log('✅ Données réelles récupérées !');
        return realData;
      }
    } catch (error) {
      console.log('⚠️ API réelle échouée, utilisation du fallback:', error);
    }

    // Fallback vers les données mockées intelligentes
    console.log('🎭 Utilisation du service Enhanced (fallback)');
    const enhancedData = await XEnhancedPreviewService.getTweetData(tweetId, username);
    
    // Convertir au format XPreviewData
    return {
      id: enhancedData.id,
      username: enhancedData.username,
      displayName: enhancedData.displayName,
      avatar: enhancedData.avatar,
      content: enhancedData.content,
      createdAt: enhancedData.createdAt,
      verified: enhancedData.verified,
      media: enhancedData.media,
      likes: enhancedData.likes,
      retweets: enhancedData.retweets,
      replies: enhancedData.replies,
      isReal: enhancedData.isReal
    };
  }

  /**
   * Essaie de récupérer les vraies données via le proxy backend
   */
  private static async tryRealApiViaProxy(tweetId: string): Promise<XPreviewData | null> {
    try {
      // URL de votre backend déployé
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://jupipotes-backend.onrender.com';
      
      console.log(`🌐 Tentative connexion backend: ${backendUrl}/api/twitter/tweet/${tweetId}`);
      
      const response = await fetch(`${backendUrl}/api/twitter/tweet/${tweetId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.log(`❌ Erreur backend: ${response.status} ${response.statusText}`);
        throw new Error(`Erreur API: ${response.status}`);
      }

      const data = await response.json();
      console.log('📋 Données réelles reçues:', data);
      
      // Convertir au format XPreviewData
      return {
        id: data.id,
        username: data.username,
        displayName: data.displayName,
        avatar: data.avatar,
        content: data.content,
        createdAt: data.createdAt,
        verified: data.verified,
        media: data.media || [],
        likes: data.likes,
        retweets: data.retweets,
        replies: data.replies,
        isReal: true // Marque les données comme réelles
      };

    } catch (error) {
      console.log('❌ Erreur proxy backend:', error);
      return null;
    }
  }

  /**
   * Test de connectivité avec le backend
   */
  static async testBackendConnection(): Promise<boolean> {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://jupipotes-backend.onrender.com';
      const response = await fetch(`${backendUrl}/health`, { method: 'GET' });
      return response.ok;
    } catch (error) {
      console.log('❌ Backend non accessible:', error);
      return false;
    }
  }
}

export default XPreviewService;
